import { Injectable, EventEmitter } from '@angular/core';
import { NotificationModel } from '../models/notification.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  static DEFAULT_TIMEOUT = 16000;
  notification$ = new EventEmitter<NotificationModel>();
  balloonNotification$ = new EventEmitter<NotificationModel>();
  hideBalloonNotification$ = new EventEmitter<string>();

  constructor() {}

  showNotification(text: string, timeout?: number) {
    this.notification$.emit({ text, timeout });
  }

  showBalloonNotification(text: string, target: HTMLElement, timeout?: number, alternatives?: boolean, side = 0) {
    this.balloonNotification$.emit({ text, parent: target, timeout, alternatives, side });
  }

  hideBalloonNotification(id: string) {
    this.hideBalloonNotification$.emit(id);
  }
}
